import { ReactComponent as LogoIcon } from './logo.svg';
import { ReactComponent as CheckIcon } from './check.svg';

export default {
  LogoIcon,
  CheckIcon,
};
